import type { ComponentType, ReactNode } from "react";

import styles from "./styles.module.css";

interface ContainerProps {
  as?: ComponentType<{ className?: string; children?: ReactNode }> | "div" | "section" | "main";
  size?: "default" | "narrow" | "wide";
  className?: string;
  children: ReactNode;
}

export function Container({ as: Tag = "div", size = "default", className, children }: ContainerProps) {
  return <Tag className={`${styles.container} ${styles[size]} ${className ?? ""}`}>{children}</Tag>;
}

export default Container;
